import { apis } from "../../../backend";

/**
 * Creates a comment associated with a call.
 * @param callId ID of the call.
 * @param message Comment message.
 */
export async function createCallComment(callId: string, message: string): Promise<{ commentId: string }> {
  const { commentId } = await apis.dial.post(`/calls-v1/${callId}/comments`, { message });
  return { commentId };
}

/**
 * Deletes a comment associated with a call.
 * @param callId ID of the call.
 * @param commentId ID of the comment.
 */
export async function deleteCallComment(callId: string, commentId: string) {
  await apis.dial.del(`/calls-v1/${callId}/comments/${commentId}`);
}